import { createAsyncThunk } from '@reduxjs/toolkit'
import { getPerpOpenOrders, PerpOrderRecord } from '../../../api/v1/perp'
import { AccountId } from '../../../types'

export const getPerpOpenOrdersAction = createAsyncThunk<
  PerpOrderRecord[],
  AccountId
>('perp/getPerpOpenOrdersAction', async (accountId) => {
  const r = await getPerpOpenOrders(accountId)
  return r.data.results
})
